var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsytLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.822,
    height: 29.41,
    viewBox: "0 0 107.822 29.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "translate(-628.493 -693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12981",
    "data-name": "Path 12981",
    d: "M12.059-36.162V-65.228H7.452v29.066Z",
    transform: "translate(621.041 758.572)",
    fill: "#ed1a3b"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Insyts",
    transform: "translate(644.315 714.119)",
    fill: "#4e4e4e",
    fontSize: 17,
    fontFamily: "CircularStd-Book, Circular Std",
    letterSpacing: "0.39em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INSYTS")), /*#__PURE__*/React.createElement("line", {
    id: "Line_1108",
    "data-name": "Line 1108",
    y2: 29.377,
    transform: "translate(638.47 693)",
    fill: "none",
    stroke: "#4e4e4e",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsytLogo);
export default __webpack_public_path__ + "static/media/InsytLogo.f8351d826bec27784d135246e7233e05.svg";
export { ForwardRef as ReactComponent };